import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class HeaderTitleService {
    private pageTitle = new Subject<string>();

    setTitle(title: string) {
        this.pageTitle.next(title);
    }

    clearTitle() {
        this.pageTitle.next();
    }

    getTitle(): Observable<string> {
        return this.pageTitle.asObservable();
    }
}
